<div class="location-selector">
  @if (locationState.isLoading()) {
  <div class="location-selector__loading">Loading locations...</div>
  } @else if (locationState.isLoaded()) {
  <div class="location-selector__dropdowns">
    <div class="location-selector__dropdown location-selector__dropdown--province">
      <label for="province" class="location-selector__label">State / Province / Region</label>
      <app-autocomplete
        #provinceAutocomplete
        [prefetchOnInit]="false"
        [options]="provinces"
        [selectedValue]="selectedProvince"
        inputName="location-province-search"
        inputAutocomplete="new-password"
        [suppressBrowserAutofill]="true"
        placeholder="Search province..."
        [minLength]="1"
        [debounceMs]="200"
        (selectionChange)="selectProvince($event)" />
    </div>

    <div class="location-selector__dropdown location-selector__dropdown--district">
      <label for="district" class="location-selector__label">County / District</label>
      <app-autocomplete
        #districtAutocomplete
        [prefetchOnInit]="false"
        [options]="districts"
        [selectedValue]="selectedDistrict"
        inputName="location-district-search"
        inputAutocomplete="new-password"
        [suppressBrowserAutofill]="true"
        placeholder="Search district..."
        [minLength]="1"
        [debounceMs]="200"
        (selectionChange)="selectDistrict($event)"
        [disabled]="!selectedProvince" />
    </div>

    <div class="location-selector__dropdown location-selector__dropdown--subdistrict">
      <label for="subdistrict" class="location-selector__label">Subdistrict / Municipality</label>
      <app-autocomplete
        #subdistrictAutocomplete
        [prefetchOnInit]="false"
        [options]="subdistricts"
        [selectedValue]="selectedSubdistrict"
        inputName="location-subdistrict-search"
        inputAutocomplete="new-password"
        [suppressBrowserAutofill]="true"
        placeholder="Search subdistrict..."
        [minLength]="1"
        [debounceMs]="200"
        (selectionChange)="selectSubdistrict($event)"
        [disabled]="!selectedDistrict" />
    </div>

    <div class="location-selector__dropdown location-selector__dropdown--village">
      <label for="village" class="location-selector__label">Commune / Village</label>
      <app-autocomplete
        #villageAutocomplete
        [prefetchOnInit]="false"
        [options]="villages"
        [selectedValue]="selectedVillage"
        inputName="location-village-search"
        inputAutocomplete="new-password"
        [suppressBrowserAutofill]="true"
        placeholder="Search village..."
        [minLength]="1"
        [debounceMs]="200"
        (selectionChange)="selectVillage($event)"
        [disabled]="!selectedSubdistrict" />
    </div>
  </div>

  <div class="location-selector__address">
    <div class="location-selector__field">
      <label for="address-line" class="location-selector__label">Address Line</label>
      <input
        id="address-line"
        name="address-line"
        type="text"
        class="location-selector__input"
        placeholder="Street address, building, etc."
        autocomplete="street-address"
        [ngModel]="addressLine"
        (ngModelChange)="onAddressLineChange($event)" />
    </div>

    <div class="location-selector__field">
      <label for="zip-code" class="location-selector__label">ZIP / Postal Code</label>
      <input
        id="zip-code"
        name="zip-code"
        type="text"
        class="location-selector__input"
        placeholder="Postal code"
        autocomplete="postal-code"
        [ngModel]="zipCode"
        (ngModelChange)="onZipCodeChange($event)" />
    </div>
  </div>
  }
</div>
